import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { StylesProvider } from "@material-ui/styles";
import { ThemeProvider } from "styled-components";

import defaultTheme from "./theme";
import Routes from "./routes/Routes";
import { setUserInfo } from "./store/auth/authActions";
import * as AuthService from "./services/auth.service";
import "./vendor/index.css";
import storageService from "./services/storage.service";
import config from "./config";
import { setTheme } from "./store/theme/themeActions";

const App = (props) => {
  const { currentTheme, setUserInfo, setTheme } = props;
  const [widthRatio, setWidthRatio] = useState(window.innerWidth / 1920);
  const [heightRatio, setHeightRatio] = useState(window.innerHeight / 1080);

  const setRatioFunction = () => {
    setWidthRatio(window.innerWidth / 1920);
    setHeightRatio(window.innerHeight / 1080);
  };

  useEffect(() => {
    // get User info
    const token = storageService.getItem(config.TOKEN_KEY);
    if (token) {
      AuthService.getUserInfo().then(res => {
        setUserInfo(res.data);
      }).catch(e => console.log(e));
    }

    const theme = storageService.getItem(config.THEME)
    if (theme) {
      setTheme(theme)
    }

    window.addEventListener('resize', setRatioFunction);

    return () => window.removeEventListener('resize', setRatioFunction);
  }, [setTheme, setUserInfo]);

  const theme = {
    ...defaultTheme[currentTheme],
    widthRatio,
    heightRatio
  };

  return (
    <StylesProvider injectFirst>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <MuiThemeProvider theme={ theme }>
          <ThemeProvider theme={ theme }>
            <Routes />
          </ThemeProvider>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    </StylesProvider>
  );
};

const mapStateToProps = (state) => ({
  currentTheme: state.themeReducer.currentTheme
});

const mapDispatchToProps = {
  setUserInfo,
  setTheme
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
